module.exports = __webpack_public_path__ + "img/kaist_gallery2.016b4563.jpg";